import { URL_CONFIG } from "./urlConfig";

const BASE_API_URL = URL_CONFIG.API_URL;

export const API_URL = {
  GET_DETAILS_BY_IMEI: `https://gadgetapi.acrossassist.com/api/FinanceVendor/getCustomerDetailsByIMEI`,
  GET_CERTIFICATE_STATUS: `${BASE_API_URL}GetStatusOfCertificate?IMEI=`,
  GENERATE_OTP_URL: `${BASE_API_URL}GenerateOTP?mobileNumber=`,
  RESEND_OTP_URL: `${BASE_API_URL}GenerateOTP?mobileNumber=`,
  VERIFY_OTP_URL: `${BASE_API_URL}VerifyOtp?mobileNumber=`,
  GET_CERTIFICATE_BY_IMEI_OR_MOBILE: (imei = "", mobile = "") =>
    `https://portal.acrossassist.com///api/partner/v1/apb/GetCertificateByImeiAndMobilenumber?mobileNumber=${mobile}&imei=${imei}`,
};
